/**
 * IGPage 投稿セクションの動作（メディア切り替え / バリエーション選択 / カート追加）。
 *
 * 投稿ページと、商品ページのモーダルの両方から使うため、
 * DOMを渡して初期化できる形にしてある。二重初期化は data-igp-ready で防ぐ。
 */
window.IGPage = window.IGPage || {};

(function () {

  function initPost(root) {
    if (!root || root.dataset.igpReady) return;
    root.dataset.igpReady = '1';

    /* ---- メディアの切り替え ---- */
    var slides = root.querySelectorAll('.igp__slide');
    var thumbs = root.querySelectorAll('.igp__thumb');
    if (slides.length > 1) {
      var index = 0;
      var show = function (next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      };
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(t.dataset.index, 10)); });
      });
      var prev = root.querySelector('.igp__nav--prev');
      var next = root.querySelector('.igp__nav--next');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
    }

    /* ---- バリエーション選択とカート追加 ---- */
    /* キャプションの色名は日本語、商品オプションは英語のことが多いので寄せる */
    var COLOR_ALIAS = {
      'ホワイト': 'WHITE', 'オフホワイト': 'OFFWHITE', 'アイボリー': 'IVORY', 'ブラック': 'BLACK',
      'ネイビー': 'NAVY', 'ブルー': 'BLUE', 'サックス': 'SAX', 'グレー': 'GRAY', 'グレイ': 'GRAY',
      'チャコール': 'CHARCOAL', 'ベージュ': 'BEIGE', 'カーキ': 'KHAKI', 'オリーブ': 'OLIVE',
      'グリーン': 'GREEN', 'ブラウン': 'BROWN', 'モカ': 'MOCHA', 'オレンジ': 'ORANGE',
      'イエロー': 'YELLOW', 'レッド': 'RED', 'ワイン': 'WINE', 'ピンク': 'PINK',
      'パープル': 'PURPLE', 'シルバー': 'SILVER', 'ゴールド': 'GOLD',
      'グレージュ': 'GREIGE', 'エクリュ': 'ECRU', 'サンド': 'SAND', 'タン': 'TAN',
      'ナチュラル': 'NATURAL', 'キナリ': 'NATURAL', '生成り': 'NATURAL', 'モスグリーン': 'MOSS',
      'ターコイズ': 'TURQUOISE', 'マスタード': 'MUSTARD', 'ラベンダー': 'LAVENDER', 'ボルドー': 'BORDEAUX'
    };
    var norm = function (value) {
      if (!value) return '';
      var v = String(value).trim().toUpperCase().replace(/[\s・\/]/g, '');
      if (COLOR_ALIAS[value.trim()]) return COLOR_ALIAS[value.trim()];
      return v;
    };

    var addToCart = function (variantId, button, message, fallbackUrl) {
      var drawer = document.querySelector('cart-drawer');
      var form = new FormData();
      form.append('id', variantId);
      form.append('quantity', 1);
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        form.append('sections', drawer.getSectionsToRender(true).map(function (s) { return s.id; }).join(','));
        form.append('sections_url', window.location.pathname);
      }
      var route = (window.FoxThemeSettings && window.FoxThemeSettings.routes && window.FoxThemeSettings.routes.cart_add_url) || '/cart/add';

      button.disabled = true;
      var label = button.textContent;
      button.textContent = '追加中…';
      message.textContent = '';
      message.removeAttribute('data-state');

      fetch(route, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: form
      })
        .then(function (res) { return res.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'カートに追加できませんでした');
          if (window.FoxThemeEvents && typeof window.FoxThemeEvents.emit === 'function') {
            window.FoxThemeEvents.emit('cart-update', res);
          }
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: res } }));
          if (!drawer) {
            window.location.href = fallbackUrl || '/cart';
            return;
          }
          message.textContent = 'カートに追加しました';
          button.textContent = label;
          button.disabled = false;
        })
        .catch(function (err) {
          message.textContent = err.message || 'カートに追加できませんでした';
          message.setAttribute('data-state', 'error');
          button.textContent = label;
          button.disabled = false;
        });
    };

    root.querySelectorAll('[data-igp-buy]').forEach(function (buy) {
      var raw = buy.querySelector('[data-igp-variants]');
      if (!raw) return;
      var variants;
      try { variants = JSON.parse(raw.textContent); } catch (e) { return; }
      if (!variants.length) return;

      var sel1 = buy.querySelector('[data-igp-opt="1"]');
      var sel2 = buy.querySelector('[data-igp-opt="2"]');
      var button = buy.querySelector('[data-igp-atc]');
      var message = buy.querySelector('[data-igp-msg]');
      if (!button) return;

      var findVariant = function () {
        var v1 = sel1 ? sel1.value : '';
        var v2 = sel2 ? sel2.value : '';
        if (sel1 && !v1) return null;
        if (sel2 && !v2) return null;
        return variants.filter(function (v) {
          return (!sel1 || v.o1 === v1) && (!sel2 || v.o2 === v2);
        })[0] || null;
      };

      /* 選んだ色で買えないサイズは選択肢から落とす */
      var syncSecond = function () {
        if (!sel2 || !sel1) return;
        var v1 = sel1.value;
        Array.prototype.forEach.call(sel2.options, function (opt) {
          if (!opt.value) return;
          var sellable = variants.some(function (v) {
            return v.o2 === opt.value && (!v1 || v.o1 === v1) && v.a;
          });
          opt.disabled = !sellable;
          opt.textContent = opt.value + (sellable ? '' : '（在庫なし）');
        });
        if (sel2.selectedOptions[0] && sel2.selectedOptions[0].disabled) sel2.value = '';
      };

      /* 選んだカラーのバリアント画像にサムネイルを差し替える */
      var item = buy.closest('.igp__item');
      var thumb = item ? item.querySelector('[data-igp-thumb]') : null;
      var syncThumb = function () {
        if (!thumb || !sel1) return;
        var v1 = sel1.value;
        var hit = v1 ? variants.filter(function (v) { return v.o1 === v1 && v.img; })[0] : null;
        var src = hit ? hit.img : thumb.dataset.defaultSrc;
        if (src && thumb.getAttribute('src') !== src) thumb.setAttribute('src', src);
      };

      var refresh = function () {
        syncSecond();
        syncThumb();
        message.textContent = '';
        message.removeAttribute('data-state');
        /* 選んだカラーに買えるサイズが1つも無いときは理由を出す */
        if (sel1 && sel1.value) {
          var anyLeft = variants.some(function (v) { return v.o1 === sel1.value && v.a; });
          if (!anyLeft) message.textContent = '選択中の' + (sel1.previousElementSibling ? sel1.previousElementSibling.textContent : 'カラー') + 'は在庫がありません';
        }
        var variant = findVariant();
        if (!variant) {
          button.disabled = true;
          button.textContent = button.dataset.labelDefault;
          return;
        }
        button.disabled = !variant.a;
        button.textContent = variant.a ? button.dataset.labelDefault : '在庫切れ';
      };

      button.dataset.labelDefault = button.textContent;

      /* 着用しているカラー・サイズが分かっていれば初期選択にする */
      var preselect = function (select, wanted) {
        if (!select) return;
        var real = Array.prototype.filter.call(select.options, function (opt) { return opt.value && !opt.disabled; });
        /* 選択肢が1つしか無いなら選ばせる意味がないので確定させる */
        if (real.length === 1) { select.value = real[0].value; return; }
        if (!wanted) return;
        var target = norm(wanted);
        var hit = Array.prototype.filter.call(select.options, function (opt) {
          return opt.value && norm(opt.value) === target;
        })[0];
        if (hit) select.value = hit.value;
      };
      preselect(sel1, buy.dataset.wornColor);
      syncSecond();
      preselect(sel2, buy.dataset.wornSize);

      if (sel1) sel1.addEventListener('change', refresh);
      if (sel2) sel2.addEventListener('change', refresh);
      refresh();

      button.addEventListener('click', function () {
        var variant = findVariant();
        if (!variant || !variant.a) return;
        addToCart(variant.id, button, message, buy.dataset.url);
      });
    });
    }

  window.IGPage.init = initPost;

  function initAll() {
    document.querySelectorAll('.igp').forEach(initPost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
